<template>
  <el-dialog
    title="添加产品"
    :visible.sync="visible"
    width="800px"
    @close="$emit('update:show', false)"
    @open="opened"
    :append-to-body="inner"
    :close-on-click-modal="false"
  >
    <el-input
      placeholder="输入件号或名称搜索"
      v-model="keyword"
      class="input-with-select"
      prefix-icon="el-icon-search"
      clearable
    ></el-input>
    <!-- <div class="el-form-item el-form--label-left" label="搜索对象">
      <label class="el-form-item__label" style="width: 80px;">搜索对象</label>
      <div class="el-form-item__content">
        <el-radio-group v-model="search_table">
          <el-radio label="item">零件</el-radio>
          <el-radio label="device">设备</el-radio>
        </el-radio-group>
      </div>
    </div>-->
    <el-table
      v-if="items.length > 0"
      ref="multipleTable"
      @selection-change="handleItemSelectionChange"
      :data="items"
      style="width: 100%"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="item.name" label="产品名称"></el-table-column>
      <el-table-column prop="item.part_number" label="件号"></el-table-column>
      <el-table-column prop="item.machine_type" label="机型"></el-table-column>
      <el-table-column prop="price" label="定价" width="100">
        <template slot-scope="scope">{{
          scope.row.item.price.toFixed(2)
        }}</template>
      </el-table-column>
      <el-table-column
        prop="stockroom.name"
        label="所在仓库"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="count"
        label="库存数量"
        width="100"
      ></el-table-column>
    </el-table>
    <div class="text-info-12 mt-10" v-else>
      {{ keyword.length > 0 ? '未找到对应产品，或产品已被添加' : '' }}
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false" size="small">取 消</el-button>
      <el-button type="primary" @click="submit" size="small">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { selectStoreItemList } from '../service/getData'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    inner: {
      type: Boolean,
      default: false,
    },
    devices: {
      type: Array,
      default: () => [],
    },
    selection: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
    keyword: 'searchItems',
    search_table: 'searchItems',
  },
  data() {
    return {
      search_table: 'item',
      keyword: '',
      visible: this.show,
      items: [],
      selectionTmp: [],
      selectedItems: [],
      lastTimestamp: 0,
    }
  },
  created() {},
  methods: {
    async searchItems() {
      let items = []
      this.items = []
      if (this.keyword && this.keyword.length > 0) {
        let res
        if (this.search_table == 'item') {
          res = await selectStoreItemList({
            table: 'item',
            query: this.keyword,
          })
        } else {
          res = await selectStoreItemList({
            table: 'device',
            query: this.keyword,
          })
        }
        if (res.code == 0) {
          items = res.data.list
        }
      }

      if (this.selection.length == 0) {
        this.items = items
      } else {
        this.items = items.filter((i) => {
          return !this.selection.some((j) => i.item_id == j.item_id)
        })
      }
    },
    handleItemSelectionChange(val) {
      this.selectionTmp = val.map((item) => {
        item.max = item.count
        item.checked = true
        return item
      })
    },
    submit() {
      this.visible = false
      this.$emit('selected', this.selectionTmp)
    },
    opened() {
      this.keyword = ''
      this.items = []
    },
  },
}
</script>